import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

import BaseStatusChip from "@/components_v2/StatusChip/BaseStatusChip";
import { STATUS_CHIPS } from "@/domains/certifications/constants";
import { StatusChipProps } from "@/domains/certifications/components/types";

const StatusChip = ({ status, className }: StatusChipProps) => {
  const { t } = useTranslation();
  const { labelKey, variant, hasCheckIcon } = STATUS_CHIPS[status];

  return (
    <BaseStatusChip
      label={t(labelKey)}
      variant={variant}
      icon={hasCheckIcon ? <Check size={12} /> : undefined}
      className={className}
    />
  );
};

export default StatusChip;
